/* eslint-disable */
import React, { Component } from "react";
import axios from "axios";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { apiUrl, uniqueID } from "../Settings/Config";
import Swal from "sweetalert2";
import cookie from "react-cookies";
import loadingImage from "../../common/images/loading_popup.gif";
var Parser = require("html-react-parser");
var qs = require("qs");
class Registerstatus extends Component {
  constructor(props) {
    super(props);
    console.log(this.props, "this.props");
    var paymentrefID = this.props.match.params?.refID || "";
    this.state = {
      loginPopup: false,
      paymentrefID: paymentrefID,
      payment_attempt: 0,
      validateimage: loadingImage,
      processingText: "We are processing registration",
      checkoutType: "",
    };
  }
  componentDidMount() {
    this.checkStatus();
  }

  checkStatus() {
    try {
      const history = this.props.history;
      const urlParams = new URLSearchParams(this.props.location.search);
      const omiseTransactionID = urlParams.get("omiseTransactionID") || "";
      if (omiseTransactionID !== "") {
        const postObject = {
          uniqueID: uniqueID,
          payment_refID: omiseTransactionID,
        };
        axios
          .post(apiUrl + "payment/checkRegisterStatusOmise", qs.stringify(postObject))
          .then((res) => {
            $.magnificPopup.close();
            if (res.data.status === "ok") {
              this.setState({ checkoutType: res.data.payment_type });
              var msg = "Registration successful";
              Swal.fire({
                title: "Success",
                html: msg,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary waves-effect waves-light",
                },
                buttonsStyling: false,
              });
              const result = res.data.result;
              localStorage.setItem("customerID", result.customerID);
              localStorage.setItem("firstName", result.firstName);
              localStorage.setItem("lastName", result?.lastName ?? '');
              localStorage.setItem("email", result.email);
              localStorage.setItem("mobile", result.mobile);
              localStorage.setItem("token", result.token);

              this.props.history.push(`/myprofile`);
            } else if (res.data.status === "waiting") {
              setTimeout(() => {
                this.checkStatus();
              }, 3000);
            } else {
              Swal.fire({
                title: "Error",
                html: res.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary waves-effect waves-light",
                },
                buttonsStyling: false,
              });
             // this.props.history.push("/");
            }
          })
          .catch((e) => {
            var errorMsg = e?.response?.data?.message || e.message;
            Swal.fire({
              title: "Error",
              html: errorMsg,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-primary waves-effect waves-light",
              },
              buttonsStyling: false,
            });
            console.error("Error fetching data:", e);
          });
      } else {
        setTimeout(() => {
          Swal.fire({
            title: "Error",
            html: "Registration faild",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary waves-effect waves-light",
            },
            buttonsStyling: false,
          });
          //history.push("/");
        }, 300);
      }
    } catch (e) {
      console.log(e, "aaaaaaaa");
    }
  }

  updateStateValue = (field, value) => {
    this.setState({ [field]: value });
  };

  onAction = (data) => {
    //this.props.history.push(data);
  };

  render() {
    return (
      <div className="main-div">
        <Header
          mainpagestate={this.state}
          prntPagePrps={this.props}
          updateStateValue={this.updateStateValue.bind(this)}
          loginPopup={this.state.loginPopup}
        />

        <div className="rel">
          <div className="container">
            <div className="bluebar">
              <div className="status-prarent">
                <div className="status-container">
                  <div id="statusContent">
                    <div className="loader ripple-loader">
                      <div></div>
                      <div></div>
                    </div>
                    <div className="message">Checking payment status...</div>
                  </div>
                </div>
              </div>

              <div
                id="processing-popup"
                className="white-popup mfp-hide popup_sec processing"
              >
                <div className="pouup_in">
                  <h3 className="title1 text-center">
                    {this.state.processingText !== ""
                      ? Parser(this.state.processingText)
                      : ""}
                  </h3>
                  <div className="process_inner">
                    <div className="process_col">
                      <div className="process_left">
                        <img src={this.state.validateimage} />
                      </div>
                      <div className="process_right">
                        <h5>Waiting for Payment Confirmation</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Footer section */}
        <Footer
          {...this.props}
          updateStateValue={this.updateStateValue.bind(this)}
        />
        {/* Donate popup - end */}
      </div>
    );
  }
}

export default Registerstatus;
